// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinnerWashing_loader__3W4qy","l2":"SpinnerWashing_l2__3YXpV"};